import { FormLabel, ModalError, SectionLabel } from "components";
import { Box, styled, Typography } from "@mui/material";
import { Fragment, useRef } from "react";
import { globalStyles } from "styles";

const FormUploadImage = ({
  label,
  caption,
  required,
  setImageLogo,
  imageUrl,
  height,
  width,
  backgroundColor,
  noLabel,
  fileSize,
  helperText,
}) => {
  const classes = globalStyles();
  const uploadInputRef = useRef(null);
  const onChange = e => {
    const selectedFiles = e.target.files[0];
    if (
      fileSize &&
      selectedFiles &&
      selectedFiles?.size > fileSize * 1024 * 1024
    ) {
      ModalError(`File size must be les than ${fileSize} MB`);
      return;
    }
    if (selectedFiles) {
      setImageLogo({
        image_url: URL.createObjectURL(selectedFiles),
        image: selectedFiles,
      });
    } else {
      setImageLogo({
        image_url: null,
        image: null,
      });
    }
  };
  return (
    <Fragment>
      {!noLabel && <FormLabel label={label || "Logo"} required={required} />}
      <Box
        position="relative"
        borderRadius="10px"
        bgcolor="#F9FAFB"
        width={width}
        height={height || "150px"}
      >
        {imageUrl && (
          <img alt="logo" src={imageUrl} className={classes?.publisherLogo} />
        )}
        <UploadContainer
          height={height}
          width={width}
          backgroundColor={backgroundColor}
          onClick={() =>
            uploadInputRef.current && uploadInputRef.current.click()
          }
        >
          <Box display="none">
            <input
              ref={uploadInputRef}
              type="file"
              accept="image/*"
              onChange={onChange}
            />
          </Box>
          <Typography fontSize={24} color="white">
            {caption || `Click to change ${label || "Logo"}`}
          </Typography>
        </UploadContainer>
      </Box>
      {helperText && <SectionLabel subTitle={helperText} />}
    </Fragment>
  );
};

const UploadContainer = styled(Box)(({ height, width, backgroundColor }) => ({
  position: "absolute",
  width: width || "100%",
  height: height || "100%",
  backgroundColor: backgroundColor || "#808080",
  top: "0px",
  borderRadius: "5px",
  opacity: "0.5",
  padding: "16px",
  textAlign: "center",
  cursor: "pointer",
}));
export default FormUploadImage;
